import { render, staticRenderFns } from "./BaseDetailItem.vue?vue&type=template&id=af3bf786&scoped=true&"
import script from "./BaseDetailItem.vue?vue&type=script&lang=js&"
export * from "./BaseDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseDetailItem.vue?vue&type=style&index=0&id=af3bf786&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3bf786",
  null
  
)

export default component.exports